"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _popover = _interopRequireDefault(require("../../components/popover/popover"));

var _assetMapper = require("../../../../lib/assetMapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NeedMobileNumberPopover =
/*#__PURE__*/
function () {
  function NeedMobileNumberPopover(el) {
    _classCallCheck(this, NeedMobileNumberPopover);

    this.template = "<p>".concat(html('getCard.numberVerificationInfo'), "</p>\n        <a href=\"https://company.cdn.overdrive.com/policies/privacy-policy.htm#whatisglc\" class=\"secondary-color\" target=\"_blank\">").concat(html('getCard.learnMore'), " \n            <i class=\"icon-forward-arrow chevron\" aria-hidden=\"true\"></i>\n        </a>\n        <div class=\"getACard-map-image-div\"><img src=\"").concat((0, _assetMapper.toStaticUrl)("img/map.svg"), "\"></div>");
    this.el = el;
  }

  _createClass(NeedMobileNumberPopover, [{
    key: "render",
    value: function render() {
      return new _popover["default"]({
        target: this.el,
        contents: this.template,
        width: 400
      });
    }
  }]);

  return NeedMobileNumberPopover;
}();

exports["default"] = NeedMobileNumberPopover;